// react core
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
// config
import conf from 'conf/config';

export default function UserLogged()
{
    useEffect(() =>
    {
        setTimeout(() =>
        {
            window.location.replace(conf.server.default_redirect_logged);
        }, 250);
    });
    return (
        <div className='logged'>
            You are already logged in, you can&nbsp;
            <Link to={conf.server.logout}>log out</Link>&nbsp;
            or&nbsp;
            <Link to={conf.server.default_redirect_logged}>continue browsing.</Link>
        </div>
    );
};